
'use strict';


const form = document.querySelector('.references-filters');

let searchKeyupTimer = null;


function loadReferences () {
    const linksItems = document.querySelector('.links-items');

    const formData = new FormData(form);
    const queryString = new URLSearchParams(formData).toString();

    window.fetch(`/ajax/links/search?${queryString}`)
        .then(response => response.text())
        .then(HtmlResponse => {
            if ( linksItems ) {
                linksItems.innerHTML = HtmlResponse;
                window.history.pushState('', '', '?'+ queryString);
            }
        });
}


export default function setupReferences () {
    if ( !form ) return;
    form.addEventListener('submit', evt => evt.preventDefault());

    const searchInput = form.querySelector('input[name="searchvalue"]');
    const radioInputs = form.querySelectorAll('input[type="radio"]');

    searchInput.addEventListener('keyup', function () {
        window.clearTimeout(searchKeyupTimer);
            searchKeyupTimer = window.setTimeout(loadReferences, 250);
    });

    radioInputs
        .forEach(input => {
            input.addEventListener('change', loadReferences);
        });
}
